module.exports = __webpack_public_path__ + "static/media/Logo.9b7f2758.svg";